import WindExposureTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/windExposureTooltip';
import { apiField, windExposureOption, WindExposureField } from 'projectDesign/components/projectConfiguration/fields/types/windExposure';

// const config: WindExposureField = {
//   label: 'windExposure',
//   type: 'Select',
//   apiField,
//   missing: undefined,
//   tooltip: WindExposureTooltip,
//   data: [
//     windExposureOption.inTown,
//     windExposureOption.openTerrain,
//     windExposureOption.openWater,
//   ],
// };

// export default config;



function makeConfig( isOs: boolean = false): WindExposureField {  
  return {
    type: 'Select',
    label: 'windExposure',
    tooltip:  WindExposureTooltip,
    apiField,
    data: [
      windExposureOption.inTown,
      windExposureOption.openTerrain,
      windExposureOption.openWater,
    ],
    disable: false
  };
}


export const WindExposure =(isOs: boolean=false)=>{
  return makeConfig(isOs);
} 